import { render, staticRenderFns } from "./EmployeeDetailsView.vue?vue&type=template&id=4289444f&scoped=true&"
import script from "./EmployeeDetailsView.vue?vue&type=script&lang=js&"
export * from "./EmployeeDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289444f",
  null
  
)

export default component.exports